// extracted by mini-css-extract-plugin
export default {"item__box":"style_item__box__6OtqA","box__left":"style_box__left__y4xne","box__right":"style_box__right__o8oRg"};